import { StatesTypes } from 'store/modules/online_search_store/types';

export interface StatesListTypes {
  id: number;
  acronym: string;
  name: string;
  principal_city: string;
}

export const StatesList: Array<StatesListTypes> = [
  {
    id: 1,
    acronym: 'AC',
    name: 'Acre',
    principal_city: 'Rio Branco',
  },
  {
    id: 2,
    acronym: 'AL',
    name: 'Alagoas',
    principal_city: 'Maceió',
  },
  {
    id: 3,
    acronym: 'AM',
    name: 'Amazonas',
    principal_city: 'Manaus',
  },
  {
    id: 4,
    acronym: 'AP',
    name: 'Amapá',
    principal_city: 'Macapá',
  },
  {
    id: 5,
    acronym: 'BA',
    name: 'Bahia',
    principal_city: 'Salvador',
  },
  {
    id: 6,
    acronym: 'CE',
    name: 'Ceará',
    principal_city: 'Fortaleza',
  },
  {
    id: 7,
    acronym: 'DF',
    name: 'Distrito Federal',
    principal_city: 'Brasília',
  },
  {
    id: 8,
    acronym: 'ES',
    name: 'Espírito Santo',
    principal_city: 'Vitória',
  },
  {
    id: 9,
    acronym: 'GO',
    name: 'Goiás',
    principal_city: 'Goiânia',
  },
  {
    id: 10,
    acronym: 'MA',
    name: 'Maranhão',
    principal_city: 'São Luís',
  },
  {
    id: 11,
    acronym: 'MG',
    name: 'Minas Gerais',
    principal_city: 'Belo Horizonte',
  },
  {
    id: 12,
    acronym: 'MS',
    name: 'Mato Grosso do Sul',
    principal_city: 'Campo Grande',
  },
  {
    id: 13,
    acronym: 'MT',
    name: 'Mato Grosso',
    principal_city: 'Cuiabá',
  },
  {
    id: 14,
    acronym: 'PA',
    name: 'Pará',
    principal_city: 'Belém',
  },
  {
    id: 15,
    acronym: 'PB',
    name: 'Paraíba',
    principal_city: 'João Pessoa',
  },
  {
    id: 16,
    acronym: 'PE',
    name: 'Pernambuco',
    principal_city: 'Recife',
  },
  {
    id: 17,
    acronym: 'PI',
    name: 'Piauí',
    principal_city: 'Teresina',
  },
  {
    id: 18,
    acronym: 'PR',
    name: 'Paraná',
    principal_city: 'Curitiba',
  },
  {
    id: 19,
    acronym: 'RJ',
    name: 'Rio de Janeiro',
    principal_city: 'Rio de Janeiro',
  },
  {
    id: 20,
    acronym: 'RN',
    name: 'Rio Grande do Norte',
    principal_city: 'Natal',
  },
  {
    id: 21,
    acronym: 'RO',
    name: 'Rondônia',
    principal_city: 'Porto Velho',
  },
  {
    id: 22,
    acronym: 'RR',
    name: 'Roraima',
    principal_city: 'Boa Vista',
  },
  {
    id: 23,
    acronym: 'RS',
    name: 'Rio Grande do Sul',
    principal_city: 'Porto Alegre',
  },
  {
    id: 24,
    acronym: 'SC',
    name: 'Santa Catarina',
    principal_city: 'Florianópolis',
  },
  {
    id: 25,
    acronym: 'SE',
    name: 'Sergipe',
    principal_city: 'Aracaju',
  },
  {
    id: 26,
    acronym: 'SP',
    name: 'São Paulo',
    principal_city: 'São Paulo',
  },
  {
    id: 27,
    acronym: 'TO',
    name: 'Tocantins',
    principal_city: 'Palmas',
  },
];

export const States: Array<StatesTypes> = [
  {
    value: 1,
    label: 'Acre',
    uf: 'AC',
  },
  {
    value: 2,
    label: 'Alagoas',
    uf: 'AL',
  },
  {
    value: 3,
    label: 'Amazonas',
    uf: 'AM',
  },
  {
    value: 4,
    label: 'Amapá',
    uf: 'AP',
  },
  {
    value: 5,
    label: 'Bahia',
    uf: 'BA',
  },
  {
    value: 6,
    label: 'Ceará',
    uf: 'CE',
  },
  {
    value: 7,
    label: 'Distrito Federal',
    uf: 'DF',
  },
  {
    value: 8,
    label: 'Espírito Santo',
    uf: 'ES',
  },
  {
    value: 9,
    label: 'Goiás',
    uf: 'GO',
  },
  {
    value: 10,
    label: 'Maranhão',
    uf: 'MA',
  },
  {
    value: 11,
    label: 'Minas Gerais',
    uf: 'MG',
  },
  {
    value: 12,
    label: 'Mato Grosso do Sul',
    uf: 'MS',
  },
  {
    value: 13,
    label: 'Mato Grosso',
    uf: 'MT',
  },
  {
    value: 14,
    label: 'Pará',
    uf: 'PA',
  },
  {
    value: 15,
    label: 'Paraíba',
    uf: 'PB',
  },
  {
    value: 16,
    label: 'Pernambuco',
    uf: 'PE',
  },
  {
    value: 17,
    label: 'Piauí',
    uf: 'PI',
  },
  {
    value: 18,
    label: 'Paraná',
    uf: 'PR',
  },
  {
    value: 19,
    label: 'Rio de Janeiro',
    uf: 'RJ',
  },
  {
    value: 20,
    label: 'Rio Grande do Norte',
    uf: 'RN',
  },
  {
    value: 21,
    label: 'Rondônia',
    uf: 'RO',
  },
  {
    value: 22,
    label: 'Roraima',
    uf: 'RR',
  },
  {
    value: 23,
    label: 'Rio Grande do Sul',
    uf: 'RS',
  },
  {
    value: 24,
    label: 'Santa Catarina',
    uf: 'SC',
  },
  {
    value: 25,
    label: 'Sergipe',
    uf: 'SE',
  },
  {
    value: 26,
    label: 'São Paulo',
    uf: 'SP',
  },
  {
    value: 27,
    label: 'Tocantins',
    uf: 'TO',
  },
];
